import { PropsWithChildren } from "react";
import { cn } from "@/core/helpers/cn";

export function BankBullet({ children, className }: PropsWithChildren<{ className?: string }>) {
  return (
    <div className="relative w-[36px] h-[36px]">
      <div className="absolute w-[36px] h-[36px] border-[#21a0384d] border rounded-full top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2" />
      <div
        className={cn(
          "absolute w-[28px] h-[28px] bg-sbank rounded-full top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 flex items-center justify-center leading-none text-dark-900 font-bold",
          className,
        )}
      >
        {children}
      </div>
    </div>
  );
}
